import React, { useEffect } from "react";
import Select from 'react-select';

import './LecturasSubtabla.css';
import SelectControl from "../SelecControl/SelectControl";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBackspace } from "@fortawesome/free-solid-svg-icons";

import { createEstructuraLectura, estructuraLectura, unidadesMedidasOpciones } from "../../utils/estructuras";

const LecturasSubtabla = ({lecturas,handleChangeActivo,modo,tablaSeleccionada, usuario,componentePadre = 'activo',opcionesUsers}) => {

    const handleChange = (e, index, prop='', value='') => {
        let newLecturas = lecturas.slice();
        if(prop != '' && value != ''){
            (newLecturas[index].uniMed == '') && newLecturas.push({...createEstructuraLectura(), user: {userName: usuario.userName, label: usuario.userName, value: usuario.userName, comUserID: usuario._id}});
            newLecturas[index][prop] = value;
        }else{
            let {name,value} = e.target;            
            newLecturas[index][name] = value;
        }
        handleChangeActivo({},'lecturas',newLecturas);
    }

    const handleDelete = (l,i) => {
        if(l.fecha != '' && l.uniMed != ''){
            let newLecturas = lecturas.slice();     
            newLecturas = newLecturas.filter((l,index) => index != i);     
            handleChangeActivo({},'lecturas',newLecturas);
        }
    }

    return <div className={`${(tablaSeleccionada != 'lecturas') && 'inactive'} lecturasSubtablaDiv`}>
        <label>Lecturas</label>
        <div className={`${(modo == 'Vista') ? 'fourColumns ' : ''}subtablaHeader`}>
            {modo != 'Vista' && <label id="labelDelete"></label>}
            <label id="labelFecha">Fecha</label>
            <label id="labelUniMed">Unidad de Medida</label>
            <label id="labelValor">Valor</label>
            <label id="labelUser">Usuario</label>
        </div>
        <div className="bodyTable">
            {(lecturas.length > 0) && lecturas.map((l,i) => <div key={i} className={`${(modo == 'Vista') ? 'fourColumns ' : ''}rrLecturasDiv`}>
                {modo != 'Vista' && <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '100%', height: '40px', cursor: "pointer" }} onClick={()=>(l.uniMed.value != 'DAYS') ? handleDelete(l,i) : alert("Esta lectura no puede eliminarse ya que es generada automaticamente por el sistema")}/>}
                <input disabled={(modo == 'Vista' || l.uniMed.value == 'DAYS')} name="fecha" type="datetime-local" value={l.fecha} onChange={(e) => handleChange(e,i)}/>
                <SelectControl disabled={l.uniMed.value == 'DAYS'} placeholder={"Seleccione una unidad de medida..."} modo={modo} idSelect={"lecturas"} handleChengeSelect={handleChange} 
                optionsSelect={unidadesMedidasOpciones} 
                valueSeleccionada={l.uniMed} tipo={'lecturas'} selectSelect={handleChange} index={i} setNuevoEditado={'Ninguno'} propToChange="uniMed"/>
                <input disabled={(modo == 'Vista') || l.uniMed.value == 'DAYS'} name="valor" id="valorInput" type="number" value={l.valor} onChange={(e) => handleChange(e,i)}/>
                <SelectControl disabled={true} placeholder={"Seleccione un usuario..."} modo={modo} idSelect={"lecturas"} handleChengeSelect={handleChange} optionsSelect={opcionesUsers} valueSeleccionada={l.user} tipo={'lecturas'} selectSelect={handleChange} index={i} setNuevoEditado={'Ninguno'} propToChange="user"/>
            </div>)}
        </div>
    </div>

}

export default React.memo(LecturasSubtabla);